<script lang="ts" setup>
type TextBlockProps = {
  topLineAlign?: "left" | "right" | "center";
};

const props = defineProps<TextBlockProps>();
</script>
<template>
  <div
    class="textblock mb-4"
    :class="props.topLineAlign ? `${props.topLineAlign}-align` : undefined"
  >
    <slot />
  </div>
</template>

<style lang="css">
.textblock::before {
  width: 150px;
  content: "";
  display: block;
  border-top-width: var(--spacing);
  border-top-color: var(--color-primary-700);
  margin-bottom: calc(var(--spacing) * 4);
}

.dark .textblock::before {
  border-top-color: var(--color-primary-400);
}

@media (max-width: 639px) {
  .textblock::before {
    margin-bottom: calc(var(--spacing));
  }
}
/* sm */
@media (min-width: 639px) {
  .textblock::before {
    width: 50px;
  }
}

/* lg - align right on large screens */
@media (min-width: 1024px) {
  .textblock::before {
    margin-left: auto;
    margin-right: 0;
  }
}

.textblock.left-align::before {
  margin-left: 0;
  margin-right: auto;
}

.textblock.center-align::before {
  margin-left: auto;
  margin-right: auto;
}

.textblock.right-align::before {
  margin-left: auto;
  margin-right: 0;
}
</style>
